'use strict';

angular
	.module('theme')
	.service('ProductTrackerService', function ($window, $timeout, TrackerService) {
		var self = this;
		self.products = [];
		self.timer = false;

		self.init = function () {
			angular.element($window).bind('scroll', function () {
				if (self.timer) {
					return;
				}

				self.timer = true;

				$timeout(function () {
					self.products.forEach(function (product) {
						product.visible = self.isElementInViewport(product.el);
					});

					self.sendEvent();

					self.timer = false;
				}, 1000);
			});

			$timeout(function () {
				self.sendEvent();
			}, 1000);
		};

		self.addProduct = function (el, product) {
			if (!product.id || product.id === '') {
				return;
			}

			product.visible = self.isElementInViewport(el);
			product.el = el;
			self.products.push(product);
		};

		self.updateProduct = function (productData, selectedData, servings) {
			var productIndex = _.findIndex(self.products, {
				id: productData.type,
			});
			if (productIndex !== -1) {
				self.products[productIndex].name = productData.longname;
				self.products[productIndex].servings = servings;
				self.products[productIndex].price = selectedData.amount;
				self.products[productIndex].persons = selectedData.number;
			}
		};

		self.productChange = function (productId, selectedData) {
			var productIndex = _.findIndex(self.products, { id: productId });
			if (productIndex !== -1) {
				self.products[productIndex].persons = selectedData.number;
				self.products[productIndex].price = selectedData.amount;
			}
			self.sendEvent();
		};

		self.sendEvent = function () {
			var impressions = [];
			var visibleProducts = _.filter(self.products, {visible: true});

			if (!visibleProducts || visibleProducts.length === 0) return;

			_.forEach(visibleProducts, function(product) {
				impressions.push({
					'name': product.name,
					'id': product.id,
					'price': product.price,
					'list':  window.location.pathname,
					'position': product.position,
					'dimension3': product.servings,
					'dimension4': product.persons
				});
			});

			TrackerService.productImpressionsEvent(impressions);
		};

		self.isElementInViewport = function (el) {
			if (!el) {
				return false;
			}

			var top = el[0].offsetTop;
			var left = el[0].offsetLeft;
			var width = el[0].offsetWidth;
			var height = el[0].offsetHeight;

			return (
				top >= window.pageYOffset &&
				left >= window.pageXOffset &&
				top + height <= window.pageYOffset + window.innerHeight &&
				left + width <= window.pageXOffset + window.innerWidth
			);
		};
	});
